'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FlickityNextDirective = FlickityNextDirective;

var _next = require('./next.controller');

function FlickityNextDirective($log, $timeout, $rootScope, FlickityConfig, FlickityService) {
    'ngInject';

    var directive = {
        restrict: 'A',
        scope: {},
        bindToController: {
            bcFlickityNext: '=?',
            bcFlickityId: '@?'
        },
        compile: function compile() {
            return {
                pre: preLinkFunction
            };
        },
        controller: _next.NextController,
        controllerAs: 'vm'
    };

    return directive;

    /**
     * Pre Link
     */
    function preLinkFunction($scope, $element, $attrs, $controller) {
        'ngInject';

        // Get the ID

        var ID = $controller.flickityId;

        // Define the broadcast names to listen for
        var selectEvent = 'Flickity:' + ID + ':cellSelect';
        var settleEvent = 'Flickity:' + $controller.flickityId + ':settle';

        // Listen
        var cellSelect = $rootScope.$on(selectEvent, function (event, data) {
            _disableButtonIfNeeded(data.instance.cells.length, data.instance.selectedIndex + 1);
        });
        var settle = $rootScope.$on(settleEvent, function (event, data) {
            _disableButtonIfNeeded(data.instance.cells.length, data.instance.selectedIndex + 1);
        });

        $element.on('click', function () {

            // Move to the next cell
            FlickityService.next($controller.flickityId, $controller.wrapAround);
        });

        /**
         * Disable button if needed
         *
         * @param {Int} index
         */
        function _disableButtonIfNeeded(index, cellCount) {

            // Disable button if at the beginning and we shouldn't wrap
            if (!$controller.wrapAround && index === cellCount) {
                $attrs.$set('disabled', 'disabled');
            } else {
                $attrs.$set('disabled', false);
            }
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/next/flickityNext.directive.js
 **/